import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=3282c1ff&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=3282c1ff&lang=less&scoped=true&"
import style1 from "./AppMain.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282c1ff",
  null
  
)

export default component.exports